<div id="header_box">
  <!-- START logged in-->
  <span *ngIf="!isLoggedIn">
    <!-- START login-->
    <span *ngIf="!showRegistration">
      <h2 class="form-title">Sign In</h2>
      <form (ngSubmit)="login.emit()" class="auth-form">
        <div class="field">
          <input
            [(ngModel)]="user.email"
            name="email"
            type="text"
            class="form-input"
            placeholder="User"
          />
        </div>
        <div class="field">
          <input
            [(ngModel)]="user.password"
            name="password"
            type="password"
            class="form-input"
            placeholder="Password"
          />
        </div>
        <div class="actions">
          <button type="submit" class="btn btn-primary">Sign In</button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="showRegistration = !showRegistration"
          >
            Register
          </button>
        </div>
      </form>
    </span>
    <!-- END login-->

    <!-- START registration-->
    <span *ngIf="showRegistration">
      <h2 class="form-title">Create Account</h2>
      <form (ngSubmit)="register.emit()" class="auth-form">
        <div class="field">
          <input
            [(ngModel)]="newUser.email"
            name="email"
            type="text"
            class="form-input"
            placeholder="User"
          />
        </div>
        <div class="field">
          <input
            [(ngModel)]="newUser.password"
            name="password"
            type="password"
            class="form-input"
            placeholder="Password"
          />
        </div>
        <div class="field">
          <select
            class="form-select"
            [(ngModel)]="newUser.currency_code"
            name="currency"
          >
            <option
              *ngFor="let currencyValue of currencies"
              [ngValue]="currencyValue"
            >
              {{currencyValue}}
            </option>
          </select>
        </div>
        <div class="actions">
          <button type="submit" class="btn btn-primary">Register</button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="showRegistration = false"
          >
            Cancel
          </button>
        </div>
      </form>
    </span>
    <!-- END registration-->
  </span>
  <!-- END logged in-->

  <!-- START not logged in-->
  <span *ngIf="isLoggedIn">
    <h2 class="form-title">Account</h2>
    <form (ngSubmit)="logout.emit()" class="auth-form">
      <table class="account-table">
        <tbody>
          <tr>
            <td>User Id</td>
            <td>{{userInfo.id}}</td>
          </tr>
          <tr>
            <td>Ext Id</td>
            <td>{{userInfo.ext_id}}</td>
          </tr>
          <tr>
            <td>Manager Id</td>
            <td>{{userInfo.manager_id}}</td>
          </tr>
          <tr>
            <td>Currency</td>
            <td>{{userInfo.currency_code}}</td>
          </tr>
        </tbody>
      </table>
      <div class="actions">
        <button type="submit" class="btn btn-primary">
          <span>Sign Out</span>
        </button>
      </div>
    </form>
  </span>
  <!-- END not logged in-->
</div>
